import styled from "styled-components";

export default styled.h1`
  color: #fff;
  margin: ${(props) => props.theme.title.margin};
  text-align: ${(props) =>
    props.textAlign ? props.textAlign : props.theme.title.textAlign};
`;
